import { useTranslation } from "react-i18next";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "~/components/ui";

interface RelationActivationDialogProps {
  open: boolean;
  onOpenChange: (next: boolean) => void;
  /** When true the action will deactivate; otherwise activate. */
  deactivate: boolean;
  processing: boolean;
  onConfirm: () => void;
}

export function RelationActivationDialog({
  open,
  onOpenChange,
  deactivate,
  processing,
  onConfirm,
}: RelationActivationDialogProps) {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {deactivate ? t("feature.entities.detail.deactivate") : t("feature.entities.detail.activate")}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {deactivate ? t("feature.entities.detail.confirmDeactivate") : t("feature.entities.detail.confirmActivate")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={processing}>{t("ui.cancel")}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} disabled={processing}>
            {t("ui.ok")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
